import { createStore } from 'vuex'

export default createStore({
  state: {
    activeMenuId: sessionStorage.activeMenuId ? sessionStorage.activeMenuId : -1,
    menuList: sessionStorage.menuList && sessionStorage.menuList !== 'undefined' ? JSON.parse(sessionStorage.menuList) : [],
    footerList: sessionStorage.footerList && sessionStorage.footerList !== 'undefined' ? JSON.parse(sessionStorage.footerList) : [],
    activeSubMenuId: sessionStorage.activeSubMenuId ? sessionStorage.activeSubMenuId : -1,
    token: sessionStorage.token ? sessionStorage.token : null,
    activeSubMenuList: sessionStorage.activeSubMenuList && sessionStorage.activeSubMenuList !== 'undefined' ? JSON.parse(sessionStorage.activeSubMenuList) : [],
    serveconsult: sessionStorage.serveconsult ? sessionStorage.serveconsult : '',
    appconsult: sessionStorage.appconsult ? sessionStorage.appconsult : '',
    cusconsult: sessionStorage.cusconsult ? sessionStorage.cusconsult : ''
  },
  getters: {
    getMenuList (state) {
      return state.menuList
    },
    getFooterList (state) {
      return state.footerList
    },
    getActiveSubMenuList (state) {
      return state.activeSubMenuList
    },
    getActiveMenuId (state) {
      return state.activeMenuId
    },
    getToken (state) {
      return state.token
    },
    getActiveMenu (state) {
      let res = null
      state.menuList.forEach(menu => {
        if (menu.id === state.activeMenuId) {
          res = menu
        }
      })
      return res
    },
    getActiveSubMenuId (state) {
      return state.activeSubMenuId
    },
    getServeconsult (state) {
      return state.serveconsult
    },
    getAppconsult (state) {
      return state.appconsult
    },
    getCusveconsult (state) {
      return state.cusconsult
    }
  },
  mutations: {
    clearToken (state) {
      state.token = null
      sessionStorage.removeItem('token')
    },
    setActiveSubMenuList (state, list) {
      state.activeSubMenuList = list
      sessionStorage.activeSubMenuList = JSON.stringify(list)
    },
    setActiveMenuId (state, id) {
      state.activeMenuId = id
      sessionStorage.activeMenuId = id
    },
    setMenuList (state, list) {
      state.menuList = list
      sessionStorage.menuList = JSON.stringify(list)
    },
    setFooterList (state, list) {
      state.footerList = list
      sessionStorage.footerList = JSON.stringify(list)
    },
    setActiveSubMenuId (state, id) {
      state.activeSubMenuId = id
      sessionStorage.activeSubMenuId = id
    },
    setServeconsult (state, serve) {
      state.serveconsult = serve
      sessionStorage.serveconsult = serve
    },
    setAppconsult (state, app) {
      state.appconsult = app
      sessionStorage.appconsult = app
    },
    setCusveconsult (state, cus) {
      state.cusconsult = cus
      sessionStorage.cusconsult = cus
    },
    setToken (state, value) {
      state.token = value
      sessionStorage.token = value
    }
  },
  actions: {
  },
  modules: {
  }
})
